<template>
    <div>
        <div class="row">
            <div class="col-md-6 d-md-flex align-items-baseline">
                <h1 class="mr-2">List of SMS Defaults</h1>
            </div>
        </div>

        <div class="card rounded-lg p-3">
            <div class="card-body overflow-auto p-0">
                <div class="table-holder table-responsive">
                    <LoaderList v-if="isLoading" class="w-100" />
                    <table
                        v-else
                        class="table list"
                        :class="{
                            'table-hover': list.length > 0
                        }"
                    >
                        <thead>
                            <tr>
                                <th>SMS Type:</th>
                                <th>Content:</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="list.length > 0">
                            <tr v-for="(item, key) in list" :key="key">
                                <td width="15%">{{ item.label }}</td>
                                <td width="80%">
                                    <html-content
                                        :isReplaceNewLine="true"
                                        :content="item.content"
                                        :showSeeLess="true"
                                        :checkForEntities="false"
                                        :expanded="smsTypeExpanded === key"
                                        @onClickSeeMore="expand(key)"
                                        @onClickSeeLess="collapse"
                                    />
                                </td>
                                <td
                                    width="5%"
                                    class="text-right small text-nowrap"
                                >
                                    <span
                                        class="cursor-pointer"
                                        @click="() => edit(item)"
                                    >
                                        Edit
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6">
                                    <i>No records available</i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <modal-create-update ref="modalCreateUpdate" @success="fetchList" />
    </div>
</template>

<script>
import { isEmpty } from "lodash";
import SMS_CONSTANT from "@/constants/sms-default";
import SMSDefaultsService from "@/services/sms-defaults.js";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        ModalCreateUpdate: () =>
            import("@/module/settings/sms-defaults/modal-create-update.vue"),
        HtmlContent: () => import("@/components/commons/html-content")
    },
    data() {
        return {
            title: "SMS Defaults",
            isLoading: true,
            list: [],
            smsTypeExpanded: null
        };
    },
    computed: {},
    async mounted() {
        this.fetchList();
    },
    methods: {
        expand(smsType) {
            this.smsTypeExpanded = smsType;
        },
        collapse() {
            this.smsTypeExpanded = null;
        },
        async fetchList() {
            this.isLoading = true;

            const res = await SMSDefaultsService.getSMSDefaults();
            let listFromResponse = res ?? [];
            let smsDefaults = SMS_CONSTANT.DEFAULT_SMS;

            listFromResponse.forEach(sms => {
                if (sms.sms_type && smsDefaults[sms.sms_type]) {
                    smsDefaults[sms.sms_type] = {
                        ...smsDefaults[sms.sms_type],
                        ...sms,
                        content: !isEmpty(sms.content)
                            ? sms.content
                            : smsDefaults[sms.sms_type]?.content
                    };
                }
            });

            this.dynamicPageTitle(this.title);
            this.list = Object.values(smsDefaults);
            this.isLoading = false;
        },
        edit(smsDefault) {
            this.$refs.modalCreateUpdate.open(smsDefault);
        }
    }
};
</script>
